import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-preview-card-experience',
  templateUrl: './preview-card-experience.component.html',
  styleUrls: ['./preview-card-experience.component.css']
})
export class PreviewCardExperienceComponent implements OnInit {
  subscription = new Subscription();
  @Input() videoPath;
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.videoPath = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoPath);
  }
}
